import { PostLayeredView } from '@maxroll-media-group/common-libs'
import { Widget } from 'leveling/widget'
import _ from 'lodash'
import React from 'react'
import './builds-list.scss'

export function BuildsList({ title, count }: { title: string; count: number }) {
  const [buildGuides, setBuildGuides] = React.useState<any[]>([])

  React.useEffect(() => {
    const url = 'https://meilisearch-proxy.maxroll.gg/indexes/wp_posts_6/search'
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer 35679298edc476d0b9f9638cdb90d362235a62550bea39d59544f694cc9d90b9'
      },
      body: JSON.stringify({
        filter: [
          '(taxonomies.category = "build-guides") AND (taxonomies.build_guide_type != "archive") AND (taxonomies.misc = "poe-league-starter")'
        ],
        limit: 100
      })
    })
      .then((response) => response.json())
      .then((result) => {
        setBuildGuides(_.shuffle(result.hits))
      })
      .catch(() => {
        // Do nothing
      })
  }, [])

  return (
    <Widget title={title} className="poe-other-builds-widget">
      <div className="poe-other-builds">
        {buildGuides.slice(0, count).map((hit, index) => {
          return (
            <PostLayeredView
              key={index}
              post={hit}
              openInNewTab={true}
              postStyle="left-faded-to-black"
              tag={{ children: 'Other Builds', tagColor: 'orange' }}
            />
          )
        })}
      </div>
    </Widget>
  )
}
